import { render, staticRenderFns } from "./externalSend.vue?vue&type=template&id=fed775b6&scoped=true&"
import script from "./externalSend.vue?vue&type=script&lang=js&"
export * from "./externalSend.vue?vue&type=script&lang=js&"
import style0 from "./externalSend.vue?vue&type=style&index=0&id=fed775b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed775b6",
  null
  
)

export default component.exports